import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Chapter, FadeUp } from "./Reveal";
import { PRESS_ARTICLES } from "../../data/content";

const Press = () => (
    <section id="press" className="bg-white py-24 md:py-32" data-testid="press-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
            <Chapter
                index="05"
                label="In the News"
                title={["Published.", "Not just promised."]}
                note="Columns by Kuunal Pruuthi, published on national tech and business platforms."
            />

            <div className="border-t border-slate-200">
                {PRESS_ARTICLES.map((a, i) => (
                    <FadeUp key={a.url} delay={i * 0.08}>
                        <motion.a
                            href={a.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`press-article-${i + 1}`}
                            whileHover="hover"
                            className="group grid md:grid-cols-12 gap-3 md:gap-6 items-center py-7 md:py-9 border-b border-slate-200"
                        >
                            <span className="md:col-span-2 font-display text-sm tracking-[0.3em] text-slate-400">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="md:col-span-3 flex items-center">
                                <img
                                    src={a.logo}
                                    alt={a.outlet}
                                    loading="lazy"
                                    className={`w-auto max-w-[160px] md:max-w-[190px] object-contain ${
                                        a.darkChip ? "h-12 md:h-14 rounded-md bg-black px-3 py-2" : "h-9 md:h-10"
                                    }`}
                                />
                                <span className="sr-only">{a.outlet}</span>
                            </span>
                            <span className="md:col-span-6 font-display font-medium tracking-tight text-xl md:text-2xl text-navy leading-snug group-hover:text-accent transition-colors duration-300">
                                {a.title}
                            </span>
                            <span className="md:col-span-1 flex md:justify-end mt-2 md:mt-0">
                                <motion.span
                                    variants={{ hover: { x: 4, y: -4 } }}
                                    transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                                    className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-slate-300 text-navy group-hover:border-accent group-hover:text-accent transition-colors duration-300"
                                >
                                    <ArrowUpRight className="w-4 h-4" />
                                </motion.span>
                            </span>
                        </motion.a>
                    </FadeUp>
                ))}
            </div>

            <FadeUp delay={0.2}>
                <p
                    className="mt-10 md:mt-12 text-sm md:text-base text-slate-500 flex items-start gap-3"
                    data-testid="press-author-byline"
                >
                    <span className="mt-2.5 h-px w-8 bg-accent shrink-0" aria-hidden="true" />
                    <span>
                        <span className="font-semibold text-navy">Kuunal Pruuthi</span>, Founder, ChatProz | Growth
                        Consultant helping brands scale with AI-led marketing
                    </span>
                </p>
            </FadeUp>
        </div>
    </section>
);

export default Press;
